export const webClientId = '1052511436219-shtpq1rnnk3kg8b6um9g7ej8lp0r9b1i.apps.googleusercontent.com'